import type { MessageDescriptor } from 'react-intl';

import type { CountryUIConfigName } from './constants';

export class CountryUIFeature<T = Record<string, string | string[] | number[] | MessageDescriptor>> {
  // The name of the UI feature configuration
  readonly name: CountryUIConfigName;

  // Optional data associated with the UI feature
  readonly data: T | undefined;

  constructor(name: CountryUIConfigName, data?: T) {
    this.name = name;
    this.data = data;
  }
}
